import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["isOpen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import flatten from 'lodash/flatten';
import isEqual from 'lodash/isEqual';
import { forwardRef, Fragment, useState } from 'react';
import { ToolbarEnum } from './types';
import { youtubeAds, linkedinAds, tiktok, instagramPosts, standard } from '@/config/previewResolutions/aspectRatios';
import { getProportionalDimensions } from '@/components/WidgetPreviewContainer/utils';
import useResolutionEditing from '@/components/WidgetPreviewContainer/LayoutControls/useResolutionEditing';
import { Dropdown, DropdownMenu, DropdownMenuItem, DropdownOpenButton, DropdownDivider } from '@/components/lists/DropdownV2';
import { MenuItem } from '@/components/ToolbarMenu';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import PreviewResolutionMenus from '@/components/WidgetPreviewContainer/LayoutControls/PreviewResolutionMenus';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L10 17.4142L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L10 14.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289Z",
      fill: "#12131A"
    })
  }));
};

CheckIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CogsIcon = function CogsIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.16674 3.20831C9.16674 2.44892 9.78235 1.83331 10.5417 1.83331H11.4584C12.2178 1.83331 12.8334 2.44892 12.8334 3.20831V3.54239C12.8334 3.75152 12.9755 3.93267 13.1752 3.99462C13.6069 4.12853 14.0216 4.30124 14.4151 4.50868C14.6001 4.60623 14.8287 4.57859 14.9766 4.43069L15.2132 4.19408C15.7502 3.65711 16.6208 3.65711 17.1577 4.19408L17.8059 4.84226C18.3429 5.37923 18.3429 6.24983 17.8059 6.7868L17.5693 7.02341C17.4214 7.17131 17.3938 7.3999 17.4913 7.58493C17.6988 7.97844 17.8715 8.39311 18.0054 8.82484C18.0673 9.02459 18.2485 9.16665 18.4576 9.16665H18.7917C19.5511 9.16665 20.1667 9.78225 20.1667 10.5416V11.4583C20.1667 12.2177 19.5511 12.8333 18.7917 12.8333H18.4576C18.2485 12.8333 18.0673 12.9754 18.0054 13.1751C17.8715 13.6069 17.6988 14.0215 17.4913 14.415C17.3938 14.6001 17.4214 14.8286 17.5693 14.9765L17.8059 15.2132C18.3429 15.7501 18.3429 16.6207 17.8059 17.1577L17.1577 17.8059C16.6208 18.3429 15.7502 18.3429 15.2132 17.8059L14.9766 17.5693C14.8287 17.4214 14.6001 17.3937 14.4151 17.4913C14.0216 17.6987 13.6069 17.8714 13.1752 18.0053C12.9755 18.0673 12.8334 18.2484 12.8334 18.4576V18.7916C12.8334 19.551 12.2178 20.1666 11.4584 20.1666H10.5417C9.78235 20.1666 9.16674 19.551 9.16674 18.7916V18.4576C9.16674 18.2485 9.02468 18.0673 8.82493 18.0054C8.39317 17.8715 7.97849 17.6987 7.58496 17.4913C7.39993 17.3937 7.17135 17.4214 7.02344 17.5693L6.78683 17.8059C6.24986 18.3429 5.37926 18.3429 4.84229 17.8059L4.19411 17.1577C3.65714 16.6207 3.65714 15.7501 4.19411 15.2132L4.43072 14.9765C4.57862 14.8286 4.60626 14.6001 4.50871 14.415C4.30126 14.0215 4.12854 13.6069 3.99464 13.1751C3.93269 12.9754 3.75153 12.8333 3.5424 12.8333H3.20834C2.44895 12.8333 1.83334 12.2177 1.83334 11.4583V10.5416C1.83334 9.78225 2.44895 9.16665 3.20834 9.16665H3.5424C3.75153 9.16665 3.93269 9.02459 3.99464 8.82484C4.12854 8.39311 4.30126 7.97844 4.50871 7.58493C4.60626 7.3999 4.57862 7.17131 4.43072 7.02341L4.19411 6.7868C3.65714 6.24983 3.65714 5.37923 4.19411 4.84226L4.84229 4.19408C5.37926 3.65711 6.24986 3.65711 6.78683 4.19408L7.02344 4.43069C7.17135 4.57859 7.39993 4.60623 7.58496 4.50868C7.97849 4.30122 8.39317 4.1285 8.82493 3.99459C9.02468 3.93264 9.16674 3.75149 9.16674 3.54236V3.20831Z",
      fill: "#12131A",
      fillOpacity: "0.25"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.75 11C13.75 12.5188 12.5188 13.75 11 13.75C9.48122 13.75 8.25 12.5188 8.25 11C8.25 9.48122 9.48122 8.25 11 8.25C12.5188 8.25 13.75 9.48122 13.75 11Z",
      fill: "#12131A"
    })]
  }));
};

CogsIcon.defaultProps = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CropToolIcon = function CropToolIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 7C3 6.44772 3.44772 6 4 6H15C16.6569 6 18 7.34315 18 9V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V9C16 8.44772 15.5523 8 15 8H4C3.44772 8 3 7.55228 3 7Z",
      fill: "#12131A",
      fillOpacity: "0.25"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 17C21 17.5523 20.5523 18 20 18L9 18C7.34315 18 6 16.6569 6 15L6 4C6 3.44771 6.44772 3 7 3C7.55229 3 8 3.44771 8 4L8 15C8 15.5523 8.44771 16 9 16L20 16C20.5523 16 21 16.4477 21 17Z",
      fill: "#515466"
    })]
  }));
};

CropToolIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const ASPECT_RATIO_BOX_SIZE = 20;
const ASPECT_RATIO_GROUPS = [[youtubeAds, linkedinAds], [tiktok, instagramPosts, standard]];

const ResizeControlsDropdown = _ref => {
  let {
    aspectRatio,
    defaultAspectRatio,
    adjustAspectRatio,
    previewGroups,
    previewResolution,
    activePreviewGroup,
    updatePreviewResolution,
    updateActivePreviewGroup
  } = _ref;
  const {
    0: isCustomResolution,
    1: setIsCustomResolution
  } = useState(false); // get aspect ratio from the current preview resolution

  const currentAspectRatio = getAspectRatio(previewResolution.value[0], previewResolution.value[1]);

  if (isCustomResolution) {
    return /*#__PURE__*/_jsx(ResizeResolutionFields, {
      previewGroups: previewGroups,
      previewResolution: previewResolution,
      activePreviewGroup: activePreviewGroup,
      updatePreviewResolution: updatePreviewResolution,
      updateActivePreviewGroup: updateActivePreviewGroup,
      onOpenChange: () => setIsCustomResolution(false)
    });
  }

  return /*#__PURE__*/_jsx(ResizeAspectRatioFields, {
    aspectRatio: (currentAspectRatio === null || currentAspectRatio === void 0 ? void 0 : currentAspectRatio.value) || aspectRatio,
    defaultAspectRatio: defaultAspectRatio,
    adjustAspectRatio: adjustAspectRatio,
    onCustomize: () => setIsCustomResolution(true)
  });
}; // Resize Aspect Ratio Fields


const resizeAspectRatioProps = ['aspectRatio', 'defaultAspectRatio', 'adjustAspectRatio'];

const ResizeAspectRatioFields = _ref2 => {
  let {
    aspectRatio,
    defaultAspectRatio,
    adjustAspectRatio,
    onCustomize
  } = _ref2;
  const currentAspectRatio = aspectRatio || defaultAspectRatio;
  const isDefaultAspectRatio = isEqual(currentAspectRatio, defaultAspectRatio);
  return /*#__PURE__*/_jsxs(Dropdown, {
    children: [/*#__PURE__*/_jsx(DropdownOpenButton, {
      Component: ResizeAspectRatioOpenButton
    }), /*#__PURE__*/_jsxs(DropdownMenu, {
      children: [/*#__PURE__*/_jsx(DropdownMenuItem, {
        text: "Original aspect ratio",
        leftIcon: /*#__PURE__*/_jsx(AspectRatioBox, {
          active: isDefaultAspectRatio,
          value: defaultAspectRatio
        }),
        rightIcon: isDefaultAspectRatio ? /*#__PURE__*/_jsx(CheckIcon, {
          className: styles.checkIcon
        }) : undefined,
        onClick: () => adjustAspectRatio(defaultAspectRatio)
      }), /*#__PURE__*/_jsx(DropdownDivider, {}), ASPECT_RATIO_GROUPS.map((group, groupIdx) => {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [group.map(ratio => {
            const isSameAsDefault = isEqual(ratio.value, defaultAspectRatio);
            const isActive = isEqual(ratio.value, currentAspectRatio);
            if (isSameAsDefault) return null;
            return /*#__PURE__*/_jsx(DropdownMenuItem, {
              leftIcon: /*#__PURE__*/_jsx(AspectRatioBox, {
                active: isActive,
                value: ratio.value
              }),
              text: `${ratio.value[0]}:${ratio.value[1]}`,
              caption: ratio.label,
              rightIcon: isActive ? /*#__PURE__*/_jsx(CheckIcon, {
                className: styles.checkIcon
              }) : undefined,
              onClick: () => adjustAspectRatio(ratio.value)
            }, ratio.id);
          }), /*#__PURE__*/_jsx(DropdownDivider, {})]
        }, `resize-group-${groupIdx}`);
      }), /*#__PURE__*/_jsx(DropdownMenuItem, {
        leftIcon: /*#__PURE__*/_jsx(CogsIcon, {}),
        text: "Custom Size",
        onClick: onCustomize
      })]
    })]
  });
};

const ResizeAspectRatioOpenButton = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    isOpen
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/_jsx(MenuItem, _objectSpread({
    id: ToolbarEnum.RESIZE,
    title: "Resize",
    icon: /*#__PURE__*/_jsx(CropToolIcon, {}),
    active: isOpen,
    ref: forwardedRef,
    classNames: {
      menuItem: styles.dropdownButton,
      menuItemActive: styles['dropdownButton--active'],
      menuItemIcon: styles.menuItemIcon,
      menuItemTitle: styles.menuItemTitle
    }
  }, props));
});
ResizeAspectRatioOpenButton.displayName = 'ResizeAspectRatioOpenButton'; // Resize Resolution Fields

const resizeResolutionProps = ['previewGroups', 'previewResolution', 'activePreviewGroup', 'updatePreviewResolution', 'updateActivePreviewGroup'];

const ResizeResolutionFields = _ref4 => {
  let {
    previewGroups,
    previewResolution,
    activePreviewGroup,
    updatePreviewResolution,
    updateActivePreviewGroup,
    onOpenChange
  } = _ref4;
  const {
    isCustomizingLayout,
    handlePreviewGroupChange,
    handleCustomResolutionChange,
    handlePreviewResolutionChange
  } = useResolutionEditing({
    previewResolution,
    activePreviewGroup,
    previewGroups,
    updatePreviewResolution,
    updateActivePreviewGroup
  });
  return /*#__PURE__*/_jsx(RevealPill, {
    label: "Resize",
    classNames: {
      container: styles.revealPillContainer
    },
    initialOpen: true,
    OpenButton: ResizeResolutionOpenButton,
    onOpenChange: onOpenChange,
    children: /*#__PURE__*/_jsx(PreviewResolutionMenus, {
      alwaysVisible: true,
      className: styles.previewResolutionMenus,
      isCustomizingLayout: isCustomizingLayout || !activePreviewGroup,
      previewResolution: previewResolution,
      activePreviewGroup: activePreviewGroup,
      previewGroups: previewGroups,
      handlePreviewGroupChange: handlePreviewGroupChange,
      handlePreviewResolutionChange: handlePreviewResolutionChange,
      handleCustomResolutionChange: handleCustomResolutionChange
    })
  });
};

const ResizeResolutionOpenButton = _ref5 => {
  let {
    isOpen,
    label,
    setReference,
    getReferenceProps
  } = _ref5;
  return /*#__PURE__*/_jsx(MenuItem, _objectSpread({
    id: ToolbarEnum.RESIZE,
    ref: setReference,
    title: label,
    icon: /*#__PURE__*/_jsx(CropToolIcon, {}),
    active: isOpen,
    classNames: {
      menuItemIcon: styles.menuItemIcon,
      menuItemTitle: styles.menuItemTitle
    }
  }, getReferenceProps()));
};

const AspectRatioBox = _ref6 => {
  let {
    active,
    value
  } = _ref6;
  const [width, height] = getProportionalDimensions(ASPECT_RATIO_BOX_SIZE, ASPECT_RATIO_BOX_SIZE, value);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.aspectRatioBox, {
      [styles['aspectRatioBox--active']]: active
    }),
    style: {
      width,
      height
    }
  });
}; // Calculate the closest aspect ratio to the input width and height.


function getAspectRatio(width, height) {
  if (width <= 0 || height <= 0) {
    return null;
  } // Calculate the greatest common divisor (GCD) of two integers.


  function gcd(a, b) {
    while (b) {
      const temp = b;
      b = a % b;
      a = temp;
    }

    return a;
  }

  const commonDivisor = gcd(width, height);
  const reducedWidth = width / commonDivisor;
  const reducedHeight = height / commonDivisor;
  let closestRatio = null;
  let minDifference = Infinity;
  const aspectRatioList = flatten(ASPECT_RATIO_GROUPS);

  for (const ratio of aspectRatioList) {
    const [targetWidth, targetHeight] = ratio.value; // Calculate the difference between the input ratio and the target ratio.
    // Using the absolute difference of the ratios (w1/h1 - w2/h2).

    const difference = Math.abs(reducedWidth / reducedHeight - targetWidth / targetHeight);

    if (difference < minDifference) {
      minDifference = difference;
      closestRatio = ratio;
    }
  }

  return closestRatio;
}

export default ResizeControlsDropdown;